import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import useDataContext from "../../providers/DataProvider/useDataContext";

interface Props {
    isHomePage?: boolean
}

const Footer: React.FC<Props> = ({ isHomePage }) => {
    const { data } = useDataContext();
    const [year, setYear] = useState(2025);

    useEffect(() => {
        setYear(new Date().getFullYear());
    }, [])

    return (
        <footer className="bg-first-solid text-fifth-solid">
            <div className="container mx-auto lg:grid lg:grid-cols-3 p-4">
                <Navbar ariaLabel="footer-nav" 
                        className="flex flex-col justify-center gap-6 text-lg py-4 lg:py-0"
                        isHomePage={isHomePage}/>

                <figure className="flex justify-center items-center py-4 lg:py-0">
                    <img src={data.components.footer.qr.src}
                         alt={data.components.footer.qr.alt}
                         className="size-40"/>
                </figure>

                <div className="flex flex-col items-center gap-1 py-4 lg:py-0">
                    <Link to={data.components.footer.mainLogo.link}
                        className="flex justify-center items-center">
                        <img src={data.components.footer.mainLogo.image.src} 
                            alt={data.components.footer.mainLogo.image.alt}
                            className="w-48 lg:w-60"/>
                    </Link>
                    <p className="text-sm">Juan Manuel de Rosas 589</p>
                    <p className="text-sm">(8400) San Carlos de Bariloche, Río Negro</p>
                    <p className="text-sm">(+54 9) 294-4245827</p>
                    <p className="text-sm">reservas@lakeinn.com.ar</p>
                </div>
            </div>
            <div aria-label="footer-copyright"
                 className="container mx-auto flex justify-center gap-1 px-4 pt-2 pb-4 text-sm">
                <span>&copy;</span>
                <span>{ year }</span>
                <span>{data.components.footer.copyright}</span>
            </div>
        </footer>
    );
}

export default Footer;
